import useSWR from "swr";
import getBuyerAPIDomain from "../getBuyerAPIDomain";
import { MappedFacetListItem } from "./filters.type";
import getFacetList from "./getFacetList";
import { StoreType } from "../StoreType";
import { useSelector } from "react-redux";
import { GET_STATE } from "../redux/slices/appSlice";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

export function useFacetList(isTrackedPage: boolean) {
  const {
    app: { isToUseAuthZero },
  }: StoreType = useSelector(GET_STATE);
  const { accessToken } = useAuth(!isToUseAuthZero);

  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  const getFacetListUrl = buyerAPIDomain
    ? new URL(`${buyerAPIDomain.href}/search/facet/list`, buyerAPIDomain)
    : null;

  if (isTrackedPage) {
    getFacetListUrl.searchParams.append("pageScope", "TrackedSearch");
  }

  const { data: facetListResult, error: facetListError } = useSWR<
    MappedFacetListItem[]
  >(
    accessToken || !isToUseAuthZero
      ? [getFacetListUrl.href, accessToken, isToUseAuthZero]
      : null,
    getFacetList,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  return { facetListResult, facetListError };
}

export default useFacetList;
